import { fetch } from '@/shared/fetch';
import { ConsultationTypeEnum } from '@/shared/enums';
import { StopWordsMap } from '@/features/booking/widgets/describe-problem/model/useStopwords';

export const fetchStopWords = async (
    consultationType: ConsultationTypeEnum,
): Promise<StopWordsMap> => {
    return await fetch<StopWordsMap>(
        `/api/consultations/stop-words?consultationType=${consultationType}`,
        'GET',
    );
};
